import { render, staticRenderFns } from "./feller.vue?vue&type=template&id=002c86f5&scoped=true&"
import script from "./feller.vue?vue&type=script&lang=js&"
export * from "./feller.vue?vue&type=script&lang=js&"
import style0 from "./feller.vue?vue&type=style&index=0&id=002c86f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002c86f5",
  null
  
)

export default component.exports